'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'pen-ruler';
var width = 512;
var height = 512;
var aliases = ["pencil-ruler"];
var unicode = 'f5ae';
var svgPathData = ['M19.8 492.2l107.5-31.6c14.1-4.2 27-11.8 37.4-22.2L407.9 195.2l-91.1-91.1L73.6 347.3c-10.4 10.4-18 23.3-22.2 37.4L19.8 492.2zM33 99.7c-15.6 15.6-15.6 40.9 0 56.6l76.5 76.5c41.1-41.1 82.2-82.2 123.3-123.3L195.3 72l-53.7 53.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L184 60.7 156.3 33c-15.6-15.6-40.9-15.6-56.6 0L33 99.7zM279.2 402.5L355.7 479c15.6 15.6 40.9 15.6 56.6 0L479 412.3c15.6-15.6 15.6-40.9 0-56.6L451.3 328l-53.7 53.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L440 316.7l-37.5-37.5c-41.1 41.1-82.2 82.2-123.3 123.3z', 'M440.2 25.9c-12.5-12.5-32.8-12.5-45.3 0L328.1 92.8l91.1 91.1L486.1 117c12.5-12.5 12.5-32.8 0-45.3L440.2 25.9zM73.6 347.3c-10.4 10.4-18 23.3-22.2 37.4L19.8 492.2l107.5-31.6c14.1-4.2 27-11.8 37.4-22.2L407.9 195.2l-91.1-91.1L73.6 347.3zm310-332.7c18.7-18.7 49.1-18.7 67.9 0l45.8 45.8c18.7 18.7 18.7 49.1 0 67.9L176 449.7c-12.3 12.3-27.5 21.3-44.2 26.2L10.3 511.7c-2.8 .8-5.8 .1-7.9-2s-2.8-5.1-2-7.9L36.1 380.2C41 363.5 50 348.3 62.3 336L383.7 14.6zM156.3 33c-15.6-15.6-40.9-15.6-56.6 0L33 99.7c-15.6 15.6-15.6 40.9 0 56.6l76.5 76.5L98.2 244.1 21.7 167.6c-21.9-21.9-21.9-57.3 0-79.2L88.4 21.7c21.9-21.9 57.3-21.9 79.2 0l76.5 76.5-11.3 11.3L195.3 72l-53.7 53.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L184 60.7 156.3 33zM267.9 413.8l11.3-11.3L355.7 479c15.6 15.6 40.9 15.6 56.6 0L479 412.3c15.6-15.6 15.6-40.9 0-56.6L451.3 328l-53.7 53.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L440 316.7l-37.5-37.5 11.3-11.3 76.5 76.5c21.9 21.9 21.9 57.3 0 79.2l-66.7 66.7c-21.9 21.9-57.3 21.9-79.2 0l-76.5-76.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenRuler = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;